// Angular Imports
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
// import { FilterPipeModule } from 'ngx-filter-pipe';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { RelationshipComponent } from './relationship.component';
import { CreateRelationshipComponent } from './create-relationship/create-relationship.component';
import { ViewRelationshipComponent } from './view-relationship/view-relationship.component';
import { RelationshipRoutingModule } from './relationship-routing.module';
// import { BrowserModule } from '@angular/platform-browser';
import { EntityComponent } from './create-relationship/entity/entity.component';
import { ExternalPartnerComponent } from './create-relationship/external-partner/external-partner.component';
import { IndividualComponent } from './create-relationship/individual/individual.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatAutocompleteModule} from '@angular/material/autocomplete';
import { RelationshipGroupAccessComponent } from './view-relationship/relationship-group-access/relationship-group-access.component';
import { RelationshipExchangeComponent } from './view-relationship/relationship-exchange/relationship-exchange.component';
import { ModelModule } from '../model/model.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import {MatSelectModule} from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { RelationshipMemberAccessComponent } from './view-relationship/relationship-member-access/relationship-member-access.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
// Cases Shared feature (Individual Relationships only)
import { CaseListComponent } from './case-information/case-list/case-list.component';
import { CaseDetailComponent } from './case-information/case-detail/case-detail.component';
import { NoteDialogComponent } from './case-information/note-dialog/note-dialog.component';
import { ShareNoteDialogComponent } from './case-information/share-note-dialog/share-note-dialog.component';
import { DocumentPreviewComponent } from './case-information/document-preview/document-preview.component';




@NgModule({
    imports: [
        RouterModule,
        FormsModule,
        CommonModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        ReactiveFormsModule,
        RelationshipRoutingModule,
        MatAutocompleteModule,
        //FilterPipeModule,
        ModelModule,
        SharedModule,
        NgxSpinnerModule,
        MatSelectModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatInputModule,
        MatFormFieldModule,
        DocumentPreviewComponent,
        BsDatepickerModule.forRoot()
        ],
    declarations: [
        RelationshipComponent,
        CreateRelationshipComponent,
        ViewRelationshipComponent,
        EntityComponent,
        ExternalPartnerComponent,
        IndividualComponent,
        RelationshipGroupAccessComponent,
        RelationshipExchangeComponent,
        RelationshipMemberAccessComponent,
        CaseListComponent,
        CaseDetailComponent,
        NoteDialogComponent,
        ShareNoteDialogComponent,
    ],
    exports: [
        
    ]
})
export class RelationshipModule {

}